import logger from "src/services/logger";

export default logger("i18n");
